<button
  *ngIf="isLoggedIn()"
  type="button"
  nz-tooltip
  [nzTooltipTitle]="companionTooltip"
  nzTooltipPlacement="left"
  nzTooltipColor="#ffffff"
  class="tax-companion-btn fixed bottom-16 right-3 z-50 flex h-14 w-14 items-center justify-center rounded-2xl bg-white border-2 border-[#42BF7966] shadow-lg"
  (click)="askTaxAI()"
>
  <span
    class="bg-[#42BF79] border-2 border-white rounded-full h-4 w-4 absolute -top-1 -right-1"
  ></span>

  <img
    class="h-8 w-auto"
    src="assets/images/nigeria-map.png"
    alt="Tax Companion"
  />
</button>

<ng-template #companionTooltip>
  <div class="px-1 py-0.5 text-left">
    <p class="text-sm font-bold text-[#226449]">Your Tax Companion</p>
    <p class="text-xs text-[#737373]">Ask me anything about tax</p>
  </div>
</ng-template>
